import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie';


@Injectable()
export class AuthService {

  baseUrl = '';
  // baseUrl = 'http://127.0.0.1:8000';

  public headersForFile: HttpHeaders;

  public headers: HttpHeaders;

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
  ) {
    let csfr = this.cookieService.get('csrftoken');
    if (typeof(csfr) === 'undefined') {
      csfr = '';
    }

    this.headers = new HttpHeaders()
      .set('content-type', 'application/json')
      .set('X-CSRFToken', csfr);

    this.headersForFile = new HttpHeaders()
      .set('X-CSRFToken', csfr);

  }

  // AUTH APIs
  login(user): Promise <any> {
    const url: string = this.baseUrl + '/api/login/';
    return this.http.post(url, user, {headers: this.headers}).toPromise();
  }
  registerUser(): Promise <any> {
    const url: string = this.baseUrl + '/api/register/';
    return this.http.post(url, '', {headers: this.headers}).toPromise();
  }
  listUser(): Promise <any> {
    const url: string = this.baseUrl + '/api/user/';
    return this.http.get(url, {headers: this.headers}).toPromise();
  }
  detailUser(idUser): Promise <any> {
    const url: string = this.baseUrl + '/api/' + idUser + '/user-detail/';
    return this.http.get(url, {headers: this.headers}).toPromise();
  }
  logout(): Promise <any> {
    const url: string = this.baseUrl + '/api/logout/';
    return this.http.post(url, '', {headers: this.headers}).toPromise();
  }
  sendEmail(newPassword): Promise <any> {
    const url = this.baseUrl + '/api/reset/';
    return this.http.post(url, newPassword, {headers: this.headers}).toPromise();
  }
  resetPassword(newPassword): Promise <any> {
    const url: string = this.baseUrl + '/api/reset-complete/' + newPassword.id + '/' + newPassword.token + '/';
    return this.http.post(url, newPassword, {headers: this.headers}).toPromise();
  }
  editUserAvatar(idUser, avatar): Promise <any> {
    const url: string = this.baseUrl + '/api/' + idUser + '/user-avatar/';
    return this.http.put(url, avatar, {headers: this.headersForFile}).toPromise();
  }

  // THREAD APIs
  addThread(thread): Promise <any> {
    const url: string = this.baseUrl + '/api/thread/';
    return this.http.post(url, thread, {headers: this.headersForFile}).toPromise();
  }
  listThread(): Promise <any> {
    const url: string = this.baseUrl + '/api/thread/';
    return this.http.get(url, {headers: this.headers}).toPromise();
  }
  editStatusThread(thread): Promise <any> {
    const url: string = this.baseUrl + '/api/' + thread.id + '/thread/';
    return this.http.put(url, thread, {headers: this.headers}).toPromise();
  }
  editThread(thread): Promise <any> {
    const idThread = thread.get('id');
    const url: string = this.baseUrl + '/api/' + idThread + '/thread/';
    return this.http.put(url, thread, {headers: this.headersForFile}).toPromise();
  }
  deleteThread(idThread): Promise <any> {
    const url: string = this.baseUrl + '/api/' + idThread + '/thread/';
    return this.http.delete(url, {headers: this.headers}).toPromise();
  }
  getThread(idThread, userID): Promise <any> {
    const url: string = this.baseUrl + '/api/' + idThread + '/thread/';
    return this.http.get(url, {headers: this.headers, params: {'userid': userID} }).toPromise();
  }
  getFileThread(idThread): Promise <any> {
    const url: string = this.baseUrl + '/api/' + idThread + '/file-thread/';
    return this.http.get(url, {headers: this.headers}).toPromise();
  }
  listReadThread(userid): Promise <any> {
    const url: string = this.baseUrl + '/api/read-thread/';
    return this.http.get(url, {headers: this.headers, params: {'userid': userid}}).toPromise();
  }

  // THREAD FAVOURITE APIs
  addFavThread(favThread): Promise <any> {
    const url: string = this.baseUrl + '/api/favorite-thread/';
    return this.http.post(url, favThread, {headers: this.headers}).toPromise();
  }
  listFavThread(userid): Promise <any> {
    const url: string = this.baseUrl + '/api/favorite-thread/';
    return this.http.get(url, {headers: this.headers, params: {'userid': userid}}).toPromise();
  }
  editFavThread(favThread): Promise <any> {
    const url: string = this.baseUrl + '/api/' + favThread.id + '/favorite-thread/';
    return this.http.put(url, favThread, {headers: this.headers}).toPromise();
  }
  deleteFavThread(idFavThread): Promise <any> {
    const url: string = this.baseUrl + '/api/' + idFavThread + '/favorite-thread/';
    return this.http.delete(url, {headers: this.headers}).toPromise();
  }
  getFavThread(idFavThread): Promise <any> {
    const url: string = this.baseUrl + '/api/' + idFavThread + '/favorite-thread/';
    return this.http.get(url, {headers: this.headers}).toPromise();
  }
  checkFavThreadAPI(favThread): Promise <any> {
    const url: string = this.baseUrl + '/api/favorite-thread-check/';
    return this.http.post(url, favThread, {headers: this.headers}).toPromise();
  }

  // MESSAGE APIs
  addMessage(message): Promise <any> {
    const url: string = this.baseUrl + '/api/message/';
    return this.http.post(url, message, {headers: this.headersForFile}).toPromise();
  }
  listMessage(): Promise <any> {
    const url: string = this.baseUrl + '/api/message/';
    return this.http.get(url, {headers: this.headers}).toPromise();
  }
  editMessage(message): Promise <any> {
    const url: string = this.baseUrl + '/api/' + message.id + '/message/';
    return this.http.put(url, message, {headers: this.headers}).toPromise();
  }
  editMessageForFile(message): Promise <any> {
    const idMessage = message.get('id');
    const url: string = this.baseUrl + '/api/' + idMessage + '/message/';
    return this.http.put(url, message, {headers: this.headersForFile}).toPromise();
  }
  deleteMessage(idMessage): Promise <any> {
    const url: string = this.baseUrl + '/api/' + idMessage + '/message/';
    return this.http.delete(url, {headers: this.headers}).toPromise();
  }
  getMessage(idMessage): Promise <any> {
    const url: string = this.baseUrl + '/api/' + idMessage + '/message/';
    return this.http.get(url, {headers: this.headers}).toPromise();
  }
  getMessagesFromThread(idThread): Promise <any> {
    const url: string = this.baseUrl + '/api/' + idThread + '/messages-from-thread/';
    return this.http.get(url, {headers: this.headers}).toPromise();
  }
  setMessageUnread(message): Promise <any> {
    const url: string = this.baseUrl + '/api/' + message.id + '/message-unread/';
    return this.http.put(url, message, {headers: this.headers}).toPromise();
  }
  setMessageRead(message): Promise <any> {
    const url: string = this.baseUrl + '/api/' + message.id + '/message-read/';
    return this.http.put(url, message, {headers: this.headers}).toPromise();
  }

  // CHANNEL APIs
  addChannel(channel): Promise <any> {
    const url: string = this.baseUrl + this.baseUrl +  '/api/channel/';
    return this.http.post(url, channel, {headers: this.headers}).toPromise();
  }
  listChannel(userid): Promise <any> {
    const url: string = this.baseUrl +  '/api/channel/';
    return this.http.get(url, {headers: this.headers, params: {'userid': userid}}).toPromise();
  }
  editChannel(channel): Promise <any> {
    const url: string = this.baseUrl + '/api/' + channel.id + '/channel/';
    return this.http.put(url, channel, {headers: this.headers}).toPromise();
  }
  deleteChannel(idChannel): Promise <any> {
    const url: string = this.baseUrl + '/api/' + idChannel + '/channel/';
    return this.http.delete(url, {headers: this.headers}).toPromise();
  }
  getChannel(idChannel): Promise <any> {
    const url: string = this.baseUrl + '/api/' + idChannel + '/channel/';
    return this.http.get(url, {headers: this.headers}).toPromise();
  }
  listThreadOfChannel(idChannel): Promise <any> {
    const url: string = this.baseUrl +  '/api/' + idChannel + '/thread-from-channel/';
    return this.http.get(url, {headers: this.headers}).toPromise();
  }

  // CATEGORY APIs
  addCategory(category): Promise <any> {
    const url: string = this.baseUrl +  '/api/category/';
    return this.http.post(url, category, {headers: this.headers}).toPromise();
  }
  listCategory(): Promise <any> {
    const url: string = this.baseUrl +  '/api/category/';
    return this.http.get(url, {headers: this.headers}).toPromise();
  }
  editCategory(category): Promise <any> {
    const url: string = this.baseUrl + '/api/' + category.id + '/category/';
    return this.http.put(url, category, {headers: this.headers}).toPromise();
  }
  deleteCategory(idCategory): Promise <any> {
    const url: string = this.baseUrl + '/api/' + idCategory + '/category/';
    return this.http.delete(url, {headers: this.headers}).toPromise();
  }
  getCategory(idCategory): Promise <any> {
    const url: string = this.baseUrl + '/api/' + idCategory + '/category/';
    return this.http.get(url, {headers: this.headers}).toPromise();
  }
  listThreadOfCategory(idCategory): Promise <any> {
    const url: string = this.baseUrl +  '/api/' + idCategory + '/thread-from-category/';
    return this.http.get(url, {headers: this.headers}).toPromise();
  }

  // STATS APIs
  numUser(): Promise <any> {
    const url: string = this.baseUrl + '/api/num-user/';
    return this.http.get(url, {headers: this.headers}).toPromise();
  }
  numConversation(): Promise <any> {
    const url: string = this.baseUrl + '/api/num-thread/';
    return this.http.get(url, {headers: this.headers}).toPromise();
  }
}
